// Auto-generated normalizer for table: Modulo
export function moduloNormalize(row) {
  return {
    idModulo: row.idModulo ?? row.IdModulo ?? row['IdModulo'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    orden: row.orden ?? row.Orden ?? row['Orden'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
